<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 10"
    fill="none"
    stroke="currentColor"
    stroke-width="1"
    aria-hidden="true"
  >
    <rect
      x="1"
      y="1.5"
      width="17"
      height="7"
      rx="1.5"
    />
    <rect
      x="3"
      y="3"
      width="13"
      height="4"
      rx=".5"
      fill="currentColor"
    />
    <rect
      x="19"
      y="3.5"
      width="1.5"
      height="3"
      rx=".5"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBattery',
  props: {
    width: { type: [String, Number], default: 22 },
    height: { type: [String, Number], default: 10 },
  },
};
</script>
